import React, { MouseEvent } from 'react';
import copy from 'copy-to-clipboard';
import i18n from 'i18next';

import { centerPopup } from '../utils/popups';

const sharersData = [
  {
    id: 'facebook',
    mandatory: true,
    label: i18n.t('main.share.facebook'),
    icon: (
      <svg viewBox="0 0 64 64" width="16" height="16">
        <circle cx="32" cy="32" r="31" fill="#3b5998" />
        <path
          d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
          fill="white"
        />
      </svg>
    ),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      const title = event.currentTarget.getAttribute('data-title');

      return centerPopup({
        url: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`,
        title,
      });
    },
  },
  {
    id: 'twitter',
    mandatory: true,
    label: i18n.t('main.share.twitter'),
    icon: (
      <svg viewBox="0 0 64 64" width="16" height="16">
        <circle cx="32" cy="32" r="31" fill="#00aced" />
        <path
          d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
          fill="white"
        />
      </svg>
    ),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      const title = event.currentTarget.getAttribute('data-title');

      return centerPopup({
        url: `https://twitter.com/share?url=${url}&text=${title}`,
        title,
      });
    },
  },
  // {
  //   id: 'ok',
  //   mandatory: true,
  //   label: i18n.t('main.share.ok'),
  //   icon: (
  //     <svg viewBox="0 0 64 64" width="16" height="16">
  //       <circle cx="32" cy="32" r="31" fill="#f2720c" />
  //       <path
  //         d="M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z "
  //         fill="white"
  //       />
  //     </svg>
  //   ),
  //   onClick: (event: MouseEvent<HTMLElement>): void => {
  //     const url = event.currentTarget.getAttribute('data-url');
  //     const title = event.currentTarget.getAttribute('data-title');
  //     const image = event.currentTarget.getAttribute('data-image');
  //
  //     return centerPopup({
  //       url: `https://connect.ok.ru/offer?url=${url}&title=${title}&imageUrl=${image}`,
  //       title,
  //     });
  //   },
  // },
  // {
  //   id: 'vk',
  //   mandatory: true,
  //   label: i18n.t('main.share.vk'),
  //   icon: (
  //     <svg viewBox="0 0 64 64" width="16" height="16">
  //       <circle cx="32" cy="32" r="31" fill="#45668e" />
  //       <path
  //         d="M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z"
  //         fill="white"
  //       />
  //     </svg>
  //   ),
  //   onClick: (event: MouseEvent<HTMLElement>): void => {
  //     const url = event.currentTarget.getAttribute('data-url');
  //     const title = event.currentTarget.getAttribute('data-title');
  //     const image = event.currentTarget.getAttribute('data-image');
  //
  //     return centerPopup({
  //       url: `https://vk.com/share.php?url=${url}&title=${title}&image=${image}`,
  //       title,
  //     });
  //   },
  // },
  {
    id: 'telegram',
    mandatory: true,
    label: i18n.t('main.share.telegram'),
    icon: (
      <svg viewBox="0 0 64 64" width="16" height="16">
        <circle cx="32" cy="32" r="31" fill="#37aee2" />
        <path
          d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
          fill="white"
        />
      </svg>
    ),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      const title = event.currentTarget.getAttribute('data-title');

      return centerPopup({
        url: `https://telegram.me/share/url?url=${url}&text=${title}`,
        title,
      });
    },
  },
  {
    id: 'viber',
    mandatory: true,
    label: i18n.t('main.share.viber'),
    icon: (
      <svg viewBox="0 0 64 64" width="16" height="16">
        <circle cx="32" cy="32" r="31" fill="#7c529e" />
        <path
          d="m31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z"
          fill="white"
        />
      </svg>
    ),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      const title = event.currentTarget.getAttribute('data-title');

      window.location.href = `viber://forward?text=${title ? title + ' | ' + url : url}`;
    },
  },
  {
    id: 'email',
    mandatory: false,
    label: i18n.t('main.share.email'),
    icon: (
      <svg viewBox="0 0 64 64" width="16" height="16">
        <circle cx="32" cy="32" r="31" fill="#7f7f7f" />
        <path d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z" fill="white" />
      </svg>
    ),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      const subject = event.currentTarget.getAttribute('data-subject');
      const body = event.currentTarget.getAttribute('data-body');

      window.location.href = `mailto:?subject=${subject}&body=${body ? body + ' | ' + url : url}`;
    },
  },
  {
    id: 'link',
    mandatory: false,
    label: i18n.t('main.share.link'),
    onClick: (event: MouseEvent<HTMLElement>): void => {
      const url = event.currentTarget.getAttribute('data-url');
      url && copy(url);
    },
  },
];

export default sharersData;
